const BASE_URL = `https://youtube-v31.p.rapidapi.com/`;
// const options = {
//     url: BASE_URL,
//     params: {
//         maxResults: '50'
//     },
//     headers: {
//         'X-RapidAPI-Key': '85cc7538bemsh3f3ca0c6ed31a73p1698d4jsna293c8104842',
//         'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
//     }
// };
// export const FetchFromApi = async (url)=>{
//     const { response } = await axios.get(`${BASE_URL}/${url}`,options);
//     return response;
// }

const options = {
    method: 'GET',
    headers: {
        // 'X-RapidAPI-Key': 'bdee39ecb2msh6cb43a8ec37b147p10d50fjsn3b0edd93c6a2',
        'X-RapidAPI-Key':'edaa9c67cbmsh1ebf7e6a64e0dd2p164e69jsn672140b9c39d',
        'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    }
};

export const FetchFromApi = async (url) => {
    const data = await fetch(`${BASE_URL}${url}&maxResults=60`, options)
    const videos = await data.json()
    return videos;
}

